import { render, staticRenderFns } from "./SkeletonNormal.vue?vue&type=template&id=31955716&scoped=true&"
import script from "./SkeletonNormal.vue?vue&type=script&lang=js&"
export * from "./SkeletonNormal.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonNormal.vue?vue&type=style&index=0&id=31955716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31955716",
  null
  
)

export default component.exports